import { type PositionsPaginatedType } from "../common/types";

export const MapPositionConnectionToPositionsPaginatedType = (positionConnection: {
  __typename: "PositionConnection";
  count: number | null;
  edges: {
    __typename: "PositionEdge";
    cursor: string;
    node: {
      __typename?: "PositionObjectType";
      id: string;
      investmentEntity: { __typename?: "AccountObjectType"; id: string; name: string };
    };
  }[];
  pageInfo: {
    __typename: "PageInfo";
    hasNextPage: boolean;
    startCursor: string | null;
    endCursor: string | null;
  };
}): PositionsPaginatedType => {
  return {
    count: positionConnection.count,
    edges: positionConnection.edges,
    pageInfo: positionConnection.pageInfo,
  };
};
